<template>
  <div :class="['v-textarea', !!value && 'v-textarea--filled']">
    <label class="v-textarea__wrapper">
      <textarea class="v-textarea__textarea" v-bind="$attrs" v-model="value" autocomplete="off" autocorrect="off" autocapitalize="off" spellcheck="false" />
      <span class="v-textarea__label">{{placeholder}}</span>
    </label>
  </div>
</template>

<script>
export default {
  inheritAttrs: false,
  data() {
    return {
      value: this.$attrs.value
    };
  },
  props: {
    placeholder: {
      type: String,
      default: null
    }
  }
};
</script>

<style scoped lang="scss">
@import "../../sass/component.scss";

.v-textarea {
  &__wrapper {
    display: flex;
    position: relative;
  }

  &__label {
    position: absolute;
    z-index: 1;
    top: 13px;
    left: 7px;
    color: #939393;
    background: #fff;
    padding: 0 5px;
    transition: all 200ms ease-out;
    cursor: text;
    pointer-events: none;

    .v-textarea--filled & {
      font-size: 0.75rem;
      transform: translateY(-25px);
    }
  }

  &__textarea {
    width: 100%;
    resize: none;
    height: 150px;
    padding: 12px 10px;
    border: 1px solid #b8b8b8;
    border-radius: 5px;
    background: #fff;
    font-size: 1rem;
    line-height: 1.5em;
    transition: all 200ms ease-out;
    font-family: "Lota Grotesque", Arial, Helvetica, sans-serif;

    &:focus ~ .v-textarea__label {
      font-size: 0.75rem;
      transform: translateY(-25px);
      background: #fff;
      color: #0084ff;
    }

    &:focus {
      outline: 0;
      border-color: #0084ff;
      box-shadow: 0 0 0 1px #0084ff;
    }
  }
}
</style>
